module.exports = __webpack_public_path__ + "static/media/page_analytics.603843d2.svg";